import * as server from "@/utils/http"

export const _page = params => server.get("/schools/page", params);
export const _get = params => server.get("/schools/get", params);
export const _updateStatus = params => server.get("/schools/updateStatus", params);
export const _save = params => server.post(params.id ? "/schools/update" : "/schools/save", params);

export const _getAllSchool = params => server.get("/schools/list", params);


